import React, {useState, useEffect, useMemo, useCallback} from 'react';
import tableHoc from '../../components/Tables/tableHoc';
import {API} from 'aws-amplify';
import { Box, Button, Typography, Grid, Dialog } from '@material-ui/core';
import IconButton from '../../components/widgets/IconButton';
import CreateIcon from "@material-ui/icons/Create";
import DeleteIcon from "@material-ui/icons/Delete";
import { toast } from 'react-toastify';
import PropTypes from 'prop-types';
import { useHistory, useRouteMatch } from 'react-router';
import Transition from '../../components/ModalTransition';
import DeleteModal from '../../components/DeleteModal';

const header = () => [
  {
    isSortable: true,
    label: 'Case Name',
    name: 'teamName',
  },
  {
    isSortable: true,
    label: 'Last Modified',
    name: 'lastModifiedDate',
  },
  {
    isSortable: true,
    label: 'Created',
    name: 'createdDate',
  },
  {
    label: ''
  }
];

const rowDefinition = (deleteMiniCase, editMiniCase) => (row, index) => [
  row.miniCase,
  row.lastModifiedDate ? new Date(row.lastModifiedDate).toLocaleString() : "",
  row.createdDate ? new Date(row.createdDate).toLocaleString() : "",
  <Grid key="actions" container justify="flex-end">
    {editMiniCase &&
      <Grid item>
        <IconButton size="small"
          variant="text"
          color="primary"
          icon={CreateIcon}
          onClick= { (e) => {
            e.preventDefault();
            editMiniCase(row._id);
          }}
        >
          edit
        </IconButton>
      </Grid>
    }
    {deleteMiniCase &&
      <Grid item>
        <IconButton
          size="small"
          variant="text"
          color="secondary"
          onClick={(e) => {
            e.preventDefault();
            deleteMiniCase(row);
          }}
          icon={DeleteIcon}
        >
          delete
        </IconButton>
      </Grid>}
  </Grid>
];

const MiniCaseList = ({reload}) => {
  const [cases, setCases] = useState([]);
  const [loading, setLoading] = useState(true);
  const history = useHistory();
  const match = useRouteMatch();
  const [deleting, setDeleting] = useState();

  useEffect(() => {
    const abortObj = {
      aborted: false
    };

    load(abortObj);
    return () => {
      abortObj.aborted = true;
    }

  }, [reload]);

  const load = async (abortObj) => {
    try {
      const cases = await API.get('mongo', '/cases/');
      if (!abortObj || !abortObj.aborted)
      {
        setCases(cases.filter((c) => c.active !== false));
      }
    } catch (e) {
      toast.error('Error retrieving emerging situations.');
    } finally {
      setLoading(false);
    }
  }

  const handleConfirmDelete = useCallback(async (id) => {
    try {
      setLoading(true);
      await API.put('mongo', `/cases/${id}`,
        {
          body: {
            active: false
          }
        }
      );
      toast.success('Emerging situation deleted');
    } catch(e) {
      toast.error('Error deleting emerging situation');
    } finally {
      setDeleting()
      load();
    }

  }, []);
  
  const handleDelete = useCallback((row) => {
    setDeleting(row);
  }, []);

  const handleCancelDelete = useCallback(() => {
    setDeleting();
  }, []);

  const onEdit = useCallback((id) => {
    history.push(`${match.url}/${id}`);
  }, []);

  const Table = useMemo(() =>
    tableHoc(rowDefinition(handleDelete, onEdit), header),
  [handleDelete, onEdit]);

  return (
    <Box
      display="flex"
      flexDirection="column"
    >
      <Typography
        variant="h4">
            Emerging Situations
      </Typography>
      <Box
        display="flex"
        flexDirection="row"
        justifyContent="flex-end"
        py={2}
      >
        <Button
          variant="contained"
          color="secondary"
          onClick={
            () => history.push(`${match.url}/create`)
          }
        >
          + new
        </Button>
      </Box>
      <Table data={cases}
        sortField='name'
        sortAscending
        loading={loading}
      />
      <Dialog
        style={{
          margin: 'auto',
        }}
        open={Boolean(deleting)}
        TransitionComponent={Transition}
        keepMounted
        disableEscapeKeyDown={true}
        fullScreen={false}
        fullWidth={false}
        disableBackdropClick={true}
        hideBackdrop={false}
        aria-labelledby='alert-dialog-slide-title'
        aria-describedby='alert-dialog-slide-description'>
        <DeleteModal handleConfirm={() => handleConfirmDelete(deleting._id)} handleCancel={handleCancelDelete} what={`Emerging Situation "${(deleting && deleting.miniCase) || ''}"`}/>
      </Dialog>
    </Box>

  );
};

MiniCaseList.propTypes = {
  history: PropTypes.object,
  reload: PropTypes.string.isRequired
};

export default MiniCaseList;
